// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 10) return "static/js/ffa2ae51a107ad433c3c.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"555c9aed3a85b7835d4c","146":"1e8e4040210c0c467ce1","147":"805fb08e59139476b580"}[chunkId] + ".chunk.js";
};